import * as z from 'zod';

export type QuoteFormSchemaT = {
    comments: string;
    agreeToTerms: boolean;
    email: string;
    phone: string;

    // hidden fields
    calculationId: string;
    planId: string;
    calculatorUrl?: string;
};

export const QuoteFormSchema = z.object({
    email: z.string().email('Invalid email address'),
    phone: z.string().min(1, 'Phone number is required'),
    comments: z.string().optional(),
    agreeToTerms: z.boolean().refine((val) => val, {
        message: 'You must agree to the terms and conditions',
    }),

    calculationId: z.string().min(1, 'Calculation ID is required'),
    planId: z.string().min(1, 'Plan ID is required'),
    calculatorUrl: z.string().optional(),
});
